import Vue from "vue";
import vuetify from "../vuetify.js";
import ContactApp from "../components/contact/ContactApp.vue";
import depsloader from "../depsloader";

export default () => {
  const element = document.querySelector("#vue-contact");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      new Vue({
        el: element,

        components: {
          ContactApp
        },

        vuetify,

        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(ContactApp)
      })
    });
  }
}

